import Vue from 'vue'
import App from './App.vue'

import { config, companyCode } from './config'
import { getAppData } from './appData'

(async () => {
  try {
    /**
     * Get AppData
     */
    const data = await getAppData(config, companyCode)

    /**
     * Throw error if no policies in AppData
     */
    if (data.policies.length === 0) {
      throw Error('Unable to locate policies')
    }

    /**
     * Render Vue app
     */
    new Vue({
      data,
      render: (h) => h(App)
    }).$mount('#app')
  } catch (error) {
    /**
     * If error, render error page
     */
    new Vue({
      render: (createElement) => {
        const title = createElement('h1', 'Failed to load Privacy policy')
        const body = createElement('p', error.message)
        return createElement('div', [title, body])
      }
    }).$mount('#app')
  }
})()
